import { history } from 'router/history';

export function navigate(name, params) {
  history.push(name, params);
}
